import { Suspense, lazy } from 'react'
import { ClientOnly } from '@tanstack/react-router'
import { LoadingState } from './LoadingState'
import type { ReactNode } from 'react'

const AccountAuth = lazy(() => import('@/contexts/AuthContext').then(module => ({ default: module.AuthProvider })))

/** Agent credentials are separate; the public company shell needs no account service. */
export function AccountAuthBoundary({ enabled, children }: { enabled: boolean; children: ReactNode }) {
  if (!enabled) return children
  return <ClientOnly fallback={<LoadingState fullPage message="Loading Horizon Tech..." />}><Suspense fallback={<LoadingState fullPage message="Loading Horizon Tech..." />}>
    <AccountAuth>{children}</AccountAuth>
  </Suspense></ClientOnly>
}
